module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkBAMAAACCzIhnAAAAIVBMVEVHcEz///////////////////////////////////////+PBM77AAAACnRSTlMAI92b8ksPemO5Mhr40wAAAO5JREFUWMPt2C0LAkEUheG7fmMS/AgmiyCTtNoshk0bxbT+A0EsJrPRuM3dNTi/0uAKCsMwb1Tu6U+4M5xyRPrGguQLkWZsUcpEBhZmJUtKCjGU5GJxlPwqeRxHaWs33ByyUDJLpUo3kExFICkEkzMmd8HkjMnnJYFkzckekzLF5PuUIHLjZMLJnJP3g3WucWhfkpeITHjFei9SA62svuXCSQZIdb3hJObEKlHiJ+IMJxEnTU7anNQ5qXHS4GTMyZaTEydLTjJOYkwiLbISJUqUKPkHYijJfTOUmxS+sctNVr5JzUnKRDzDnYvkC3kCWtSUogXMaJcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ../components/icon/svg/facebook.png
// module id = 410
// module chunks = 0